import { frw } from '@sfidanza/tahr';

export const notes = new frw.Template();
